import React, { useEffect, useRef, useState } from 'react'
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { AnimationPage, AnimationPageType } from '../../../cvp-webgames-core/UI/Animation/animation-page';
import { constants } from '../../../misc/constants';
import { BaseConfig } from '../../BaseConfig';
import PopUp1 from '../../general/pop-up1';

import "./initial-window.css"
import { getGlobalTextSizeStyle, getSaveData, TextHtmlTagType } from '../../../misc/tools';

class InitialWindowCaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'bg',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/main-menu-bg.png'
			},
			{
				type: PrecacheItemType.Image,
				key: 'enabled',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/accessibility-enabled.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'disabled',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/accessibility-disabled.svg'
			}
		];
	}
}

export const initialWindowCaching = new InitialWindowCaching();

const InitialWindow = (props: InitialWindowConfig) => {
	const [animateOut, setAnimateOut] = useState(false);
	if(!animateOut) {
		localStorage.setItem('isInAccessibilityScreen-jcdst', '1');
	}
		
	return (
		<div className={"modal-disable-select initial-window-container"} style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<img className={`initial-window-container-bg${animateOut ? '-animation' : ''}`} src={initialWindowCaching.getItemByKey('bg').src} alt='' style={{
				position: 'absolute',
				width: '100%',
				top: '0',
				left: '0'
			}}/>
			<PopUp1
				mainMenu= {true}
				onUpdateRoot={(r) => {
					props.animation.updateProps({
						page: r.current
					});
				}}
				title= {constants.projectTitle}
				rootClass={props.animation.getInitialClass()}
				buttons={[
					{
						imgSrc: initialWindowCaching.getItemByKey('enabled').src,
						alt508: '',
						width: '95%',
						height: '240px',
						hoverColor: '#bfddff',
						bgColor: undefined,
						buttonText2: (isHovering: boolean) => {
							return (
								<div>
									<h1 style={{...getGlobalTextSizeStyle(TextHtmlTagType.h1)}} className='title-text black-text header1-text'>Accessibility Features</h1>
									<h2 style={{...getGlobalTextSizeStyle(TextHtmlTagType.h2)}} className='title-text enabled-text'>ENABLED</h2>
									<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text black-text'>Choose this option if you need access to the <b>Visual Focus</b> feature.</p>
								</div>
							)
						},
						onClick: () => {
							localStorage.setItem('isInAccessibilityScreen-jcdst', '0');
							if(getSaveData().isAnimationsEnabled) {
								setAnimateOut(true);
							}
							props.onClick(true)
						},
						mainMenu: true
					},
					{
						imgSrc: initialWindowCaching.getItemByKey('disabled').src,
						alt508: '',
						width: '95%',
						height: '240px',
						hoverColor: '#bfddff',
						bgColor: undefined,
						buttonText2: (isHovering: boolean) => {
							return (
								<div>
									<h1 style={{...getGlobalTextSizeStyle(TextHtmlTagType.h1)}} className='title-text black-text header1-text'>Accessibility Features</h1>
									<h2 style={{...getGlobalTextSizeStyle(TextHtmlTagType.h2)}} className='title-text disabled-text'>DISABLED</h2>
									<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text black-text'>If you do not need the <b>Visual Focus</b> feature enabled, then choose this option.</p>
								</div>
							)
						},
						onClick: () => {
							localStorage.setItem('isInAccessibilityScreen-jcdst', '0');
							if(getSaveData().isAnimationsEnabled) {
								setAnimateOut(true);
							}
							props.onClick(false)
						},
						mainMenu: true
					}
				]}
				onRenderContent={() => {
					return (
						<p style={{textAlign: 'center', color: 'white', ...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='default-text center-element-horizontal'>
							How would you like to train today?
						</p>);
				}}
				onRenderContent2={() => {
					return (
						<p style={{textAlign: 'center', color: 'white', ...getGlobalTextSizeStyle(TextHtmlTagType.p)}} className='default-text center-element-horizontal'>
							You can change this option later in the <b>Settings Menu</b> if you choose.
						</p>);
				}}></PopUp1>
		</div>
	);

};

export interface InitialWindowConfig extends BaseConfig {
	animation: AnimationPage;
	onClick: (isAccessibilityEnabled: boolean) => void;
}

export default InitialWindow;
